export default __webpack_public_path__ + "images/picture_choose-from-1000s-of-items_all-products.webp?268f3f28abde09d21e2b43bf7c8201e6";